import { Injectable } from '@angular/core';
import { GridVisualData, TileVisualData } from './visual-data';

@Injectable({
  providedIn: 'root'
})
export class GridStructureService {

  constructor() { }

  getGridBySize(size: number) : GridVisualData{
    if (size == 1){
      const gridDetails :GridVisualData = {"size":1, "defaultHeight": 4, "defaultWidth": 4};
      return gridDetails;
    }
    else if (size == 2){
      const gridDetails :GridVisualData = {"size":2, "defaultHeight": 3, "defaultWidth": 2};
      return gridDetails;
    }
    else if (size == 3){
      const tileData_1 : TileVisualData =  {"index": 3, "height":3, "width":2};
      const gridDetails :GridVisualData = {"size":3, "defaultHeight": 3, "defaultWidth": 1, "tilesData":[tileData_1]};
      return gridDetails;
    }
    else if (size == 4){
      const gridDetails :GridVisualData = {"size":4, "defaultHeight": 3, "defaultWidth": 1};
      return gridDetails;
    }
    else if (size == 5){
      const tileData_1 : TileVisualData =  {"index": 1, "height":1, "width":2};
      const tileData_4 : TileVisualData =  {"index": 4, "height":2, "width":1};
      const tileData_5 : TileVisualData =  {"index": 5, "height":2, "width":1};
      const tilesData : TileVisualData[] = [tileData_1, tileData_4, tileData_5]; 
      const gridDetails :GridVisualData = {"size":5, "defaultHeight": 3, "defaultWidth": 1, "tilesData":tilesData};
      return gridDetails;
    }
    else if (size == 6){
      const gridDetails :GridVisualData = {"size":6, "defaultHeight": 1, "defaultWidth": 2};
      return gridDetails;
    }
    else if (size == 7){
      const tileData_5 : TileVisualData =  {"index": 5, "height":2, "width":1};
      const tileData_6 : TileVisualData =  {"index": 6, "height":2, "width":1};
      const tileData_7 : TileVisualData =  {"index": 7, "height":2, "width":2};
      const tilesData : TileVisualData[] = [tileData_5, tileData_6, tileData_7]; 
      const gridDetails :GridVisualData = {"size":7, "defaultHeight": 1, "defaultWidth": 1, "tilesData":tilesData};
      return gridDetails;
    }
    else if (size == 8){
      const tileData_5 : TileVisualData =  {"index": 5, "height":2, "width":1};
      const tileData_6 : TileVisualData =  {"index": 6, "height":2, "width":1};
      const tileData_7 : TileVisualData =  {"index": 7, "height":2, "width":1};
      const tileData_8 : TileVisualData =  {"index": 8, "height":2, "width":1};
      const tilesData : TileVisualData[] = [tileData_5, tileData_6, tileData_7, tileData_8]; 
      const gridDetails :GridVisualData = {"size":8, "defaultHeight": 1, "defaultWidth": 1, "tilesData":tilesData};
      return gridDetails;
    }
    else if (size == 9){
      const tileData_5 : TileVisualData =  {"index": 5, "height":2, "width":1};
      const tileData_6 : TileVisualData =  {"index": 6, "height":1, "width":2};
      const tileData_7 : TileVisualData =  {"index": 7, "height":2, "width":1};
      const tilesData : TileVisualData[] = [tileData_5, tileData_6, tileData_7]; 
      const gridDetails :GridVisualData = {"size":9, "defaultHeight": 1, "defaultWidth": 1, "tilesData":tilesData};
      return gridDetails;
    }
    else if (size == 10){
      const tileData_8 : TileVisualData =  {"index": 8, "height":2, "width":1};
      const tileData_10 : TileVisualData =  {"index": 10, "height":1, "width":2};
      const tilesData : TileVisualData[] = [tileData_8, tileData_10]; 
      const gridDetails :GridVisualData = {"size":10, "defaultHeight": 1, "defaultWidth": 1, "tilesData":tilesData};
      return gridDetails;
    }
    else if (size == 11){
      const tileData_8 : TileVisualData =  {"index": 8, "height":2, "width":1};
      const tilesData : TileVisualData[] = [tileData_8]; 
      const gridDetails :GridVisualData = {"size":11, "defaultHeight": 1, "defaultWidth": 1, "tilesData":tilesData};
      return gridDetails;
    }
    else //(size == 12)
    {
      const gridDetails :GridVisualData = {"size":12, "defaultHeight": 1, "defaultWidth": 1};
      return gridDetails;
    }
}

getGridTileSize (gridSize: number, gridTileIndex: number) : TileVisualData{
  if (gridSize > 12){
    const tileData : TileVisualData = {index:1, height: 1, width:1}
    return tileData;
  }

  const gridDetails = this.getGridBySize(gridSize);

  let foundTileDetails = null;

  if (gridDetails.tilesData != undefined){
    for (let currTile of gridDetails.tilesData){
      if (currTile.index == gridTileIndex){
        foundTileDetails = currTile;
      }
    }
  }

  if (foundTileDetails == null){
    const defaultTileDetails : TileVisualData = {index:gridTileIndex, height:gridDetails.defaultHeight, width:gridDetails.defaultWidth};
    return defaultTileDetails;
  }
    
  return foundTileDetails;
}

}
